export default "/assets/website/images/2018.jpeg?e561d63c3b572af53e9d92fd1e7956b1";